import { combineReducers } from 'redux';

export const menuActive = (state: any = { menu: '' }, action: any) => {
  switch (action.type) {
    case 'CHANGE_MENU_ACTIVE':
      return { ...state, menu: action.menu };
    default:
      return state;
  }
};

export const enableSecretButton = (state = false, action: any) => {
  switch (action.type) {
    case 'ABRA_KADABRA':
      return true;
    default:
      return state;
  }
};

export const reducer = combineReducers({
  menuActive,
  enableSecretButton,
});
